// extracted by css-extract-rspack-plugin
export default {"Box":"column-drop-zone-sash-module__Box__M4X9J","Box_1":"column-drop-zone-sash-module__Box_1__BT_TR"};